import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription, interval } from "rxjs";


@Component({
  selector: 'app-general-popup',
  templateUrl: './general-popup.component.html',
  styleUrls: ['./general-popup.component.scss']
})
export class GeneralPopupComponent implements OnInit, OnDestroy{

  timer:number = 60; //1mins
  timerSub : Subscription;
  formattedTime:string='';
  //default values
  @Input() popup_title:string='Reservation Locked';
  @Input() popup_content:string='Another user is currently editing this reservation.<br />You will not be able to make changes at this time.';
  @Input() continueCancelButtons:boolean = false;

  @Output() extendOrCancelEvent = new EventEmitter<string>();
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if(this.continueCancelButtons){
      this.startTimer();
    }
  }

  closePopup(){
    this.activeModal.close();
  }

  emitResponse(action:string){
    this.extendOrCancelEvent.emit(action);
    this.stopTimer();
    this.closePopup();
  }

  startTimer(){
    this.timerSub = interval(1000).subscribe(()=>{
      if(this.timer > 0){
        this.timer--;
        const min = Math.floor(this.timer / 60);
        const seconds = this.timer % 60;
        this.formattedTime = `${this.padZero(min)}:${this.padZero(seconds)}`;
      }
      else{
        this.stopTimer();
        this.emitResponse('cancel');
      }
    })
  }
  stopTimer(){
    if(this.timerSub){
      this.timerSub?.unsubscribe();
    }
  }
  padZero(time:number):string{
    return time <10 ? `0${time}` : time?.toString();
  }

  ngOnDestroy(): void {
    this.timerSub?.unsubscribe();
  }
}